import { useTranslation } from "react-i18next";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
 import { UserListTableData } from "../../../data/users/UsersList";
import { H4, Image, P } from "../../../AbstractElements";
import { dynamicImage } from "../../../service";
import { useRoles } from "../../../context/RolesContext";
import Breadcrumbs from "../../../common-elements/breadcrumbs/Breadcrumbs";

function ViewUserPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { role, id } = useParams<{ role?: string; id?: string }>();
  const { roles, isLoading } = useRoles();
  const [user, setUser] = useState<(typeof UserListTableData)[number] | null>(null);

  useEffect(() => {
    if (!isLoading) {
       if (!role || !roles.includes(role.toLowerCase()) || !id || !UserListTableData.find((u) => u.id.toString() === id)) {
        navigate(`${process.env.PUBLIC_URL}/error`, { replace: true });
      } else {
        const foundUser = UserListTableData.find((u) => u.id.toString() === id);
        if (foundUser) {
          setUser(foundUser);
        } else {
          navigate(`${process.env.PUBLIC_URL}/error`, { replace: true });
        }
      }
    }
  }, [role, id, roles, isLoading, navigate]);

  const getRoleTranslation = (roleStr: string | undefined) => {
    if (!roleStr) return t("Users");
    const formattedRole = roleStr.charAt(0).toUpperCase() + roleStr.slice(1).toLowerCase();
    const translated = t(formattedRole);
    return translated === formattedRole ? formattedRole : translated;
  };

  if (isLoading || !user) {
    return <div>{t("Loading")}...</div>;
  }

  const breadcrumbLinks = [
    {
      label: t("Users"),
      link: `${process.env.PUBLIC_URL}/users/${role!.toLowerCase()}`,
    },
    {
      label: getRoleTranslation(role),
      link: `${process.env.PUBLIC_URL}/users/${role!.toLowerCase()}`,
    },
  ];

  return (
    <>
      <Breadcrumbs
        mainTitle={t("Profile")}
        parents={breadcrumbLinks}
      />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <Row>
                  <Col md="4" className="text-center">
                    <Image
                      src={dynamicImage(user.image)}
                      alt={user.name}
                      className="img-fluid rounded-circle mb-3"
                      style={{ width: 150, height: 150 }}
                    />
                    <H4>{user.name}</H4>
                     <P
                      className={`text-${
                        user.status === "Active" ? "success" : "secondary"
                      }`}
                    >
                      {user.status}
                    </P>
                  </Col>
                  <Col md="8">
                    <Row>
                      <Col sm="6">
                        <P>
                          <strong>{t("Email")}:</strong> {user.email}
                        </P>
                        <P>
                          <strong>{t("Phone")}:</strong> {user.phonenumber}
                        </P>
                        <P>
                          <strong>{t("Gender")}:</strong> {user.gender}
                        </P>
                      </Col>
                      <Col sm="6">
                        <P>
                          <strong>{t("Birth Date")}:</strong> {user.birthDate}
                        </P>
                        <P>
                          <strong>{t("Role")}:</strong>{" "}
                          {getRoleTranslation(role)}
                        </P>
                       
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ViewUserPage;